export const featureFlag = (state, featureFlagKey) =>
  state.session.featureFlags[featureFlagKey];
export const featureFlags = (state) => state.session.featureFlags;
